import styled from "@emotion/styled/macro";
import { tokens } from "@sunrun/experience-ui-components";
import { TreeRemovalLegend } from "components/molecules/TreeRemovalLegend";
import { useStorefrontDesignImages } from "hooks/useStorefrontDesignImages";

type DesignRenderProps = {
  designId?: string;
  designVersion?: number;
  style?: React.CSSProperties;
  showTreeRemovalLegend?: boolean;
};

const DesignRender = ({
  designId,
  designVersion,
  style,
  showTreeRemovalLegend,
}: DesignRenderProps) => {
  const designImages = useStorefrontDesignImages(designId, designVersion);
  const imageUrl =
    designImages.data?.largeImageUrl ?? designImages.data?.smallImageUrl;

  if (!imageUrl) {
    return null;
  }

  return (
    <div>
      {showTreeRemovalLegend && <ModalTreeRemovalLegend />}
      <DesignImageScrollArea style={style} hasLegend={!!showTreeRemovalLegend}>
        <DesignImage
          src={imageUrl}
          alt="Solar design"
          data-testid="leaflet-image-render"
          hasLegend={!!showTreeRemovalLegend}
        />
      </DesignImageScrollArea>
    </div>
  );
};

const ModalTreeRemovalLegend = styled(TreeRemovalLegend)`
  border-radius: 8px 8px 0 0;
`;

const DesignImageScrollArea = styled.div<{ hasLegend: boolean }>`
  max-height: calc(90vh - 120px);
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${tokens.BACKGROUND_DARK};
  border-radius: ${({ hasLegend }) => (hasLegend ? "0 0 8px 8px" : "8px")};
`;

const DesignImage = styled.img<{ hasLegend: boolean }>`
  max-width: 100%;
  width: 100%;
  height: auto;
  display: block;
  border-radius: ${({ hasLegend }) => (hasLegend ? "0 0 8px 8px" : "8px")};
`;

export { DesignRender };
